import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../landing/Header";
import Footer from "../landing/Footer";

export default function StaticPageLayout({ pageTitle, h1, children }) {
  useEffect(() => {
    document.title = pageTitle;
    window.scrollTo(0, 0);
  }, [pageTitle]);

  return (
    <div className="min-h-screen flex flex-col pc-bg">
      <Header />
      <main className="flex-1">
        <div className="mx-auto w-full max-w-[800px] px-5 py-10 lg:py-16 lg:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[14px] font-medium text-[var(--pc-blue)] hover:underline"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={2} />
            Retour à l'accueil
          </Link>
          <h1 className="mt-8 text-balance text-[1.75rem] font-semibold leading-[1.2] tracking-[-0.03em] text-[var(--pc-ink)] sm:text-[2rem]">
            {h1}
          </h1>
          <div className="mt-10 text-[15.5px] leading-[1.7] text-[var(--pc-muted)]">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
